module.exports = __webpack_public_path__ + "static/media/administration.cafcbc2f.svg";